import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: "en", // set locale
    messages: {
        en: {
            message: {
                // home page title
                Welcome: "Welcome to the FT207 website of CTS GROUP",

                // error messages
                FieldRequired: "This field is required.",
                FirstCharRule:
                    "Company name must start with either capital letter or a number.",
                FirstCharTransporter:
                    "Transporter name must start with either capital letter or a number.",
                InvalidEmail: "Invalid e-mail.",
                InvalidTime: "Invalid time",
                InvalidDate: "Invalid date.",
                DateError:
                    "Arrival date and time error. Please check your input.",
                OnlyLetters: "Only Letters allowed.",
                Max19Chars: "Maximum 19 characters allowed",
                Max31Chars: "Maximum 31 characters allowed",
                Max44Chars: "Maximum 44 characters allowed",
                Max59Chars: "Maximum 59 characters allowed",
                Max63Chars: "Maximum 63 characters allowed",
                Max127Chars: "Maximum 127 characters allowed",
                SpecialCharacters: "Some special characters are not allowed",
                OnlyInteger: "Only integer allowed",

                // common use
                Company: "Company", // used in company and users entities
                Add: "add",
                // toolbar
                Home: "Home",
                Users: "Users",
                Registrations: "Registrations",
                Recurring_Registrations: "Recurring Registrations",
                Registrations_Archive: "Registrations Archive",
                ResetToDefaultDates: "Reset to default dates",
                Settings: "Settings",
                LogOut: "Log out",
                Updated: "Updated",
                UnableToRefresh: "Unable to refresh",

                // search option
                Search: "Search",
                YourSearch: "Your search for",
                NoResults: "found no results",

                // home
                TotalToday: "Total<br>Today",
                FinishedToday: "Finished<br>Today",
                DidNotShowToday: "Did not show<br>Today",
                OpenToday: "Open<br>Today",
                Total: "Total",
                Finished: "Finished",
                DidNotShowUp: "Did not show up",

                // users
                NewUser: "Add User",
                EditUser: "Edit User",
                ListUsersTitle: "Users",
                Name: "Name",
                Email: "Email",
                Phone: "Phone Number",
                Ldap: "Ldap Login",
                Group: "Group",
                Actions: "Actions",
                SaveButton: "Save",
                CancelButton: "Cancel",

                // company
                Companies: "Companies",
                AddCompany: "Add Company",
                NewCompany: "New Company",
                EditCompany: "Edit Company",

                // trucks registrations list
                FormTrucksTitle: "Truck Registrations",
                Status: "Status",
                Date: "Date",
                Days: "Days",
                Time: "Time",
                Type: "Type",
                Transporter: "Transporter",
                Reference: "Reference Number",
                LastModified: "Last Modified",
                registerButton: "Register",
                From: "from",
                To: "to",
                NotKnown: "Not known",
                Undo: "Undo",
                Busy: "Note: Take longer waiting times into account",
                // truck registrations form

                // email address and company name are already defined
                ContactPerson: "Contact person",
                StartDate: "Start date",
                EndDate: "End date",
                ArrivalTimeFrom: "Arrival time from",
                ArrivalTimeTo: "Arrival time to",
                // type, ref num and trasporter are already defined
                NameDriver: "Name driver",
                LicensePlate: "License plate",
                Dock: "Dock",
                CustomerRemarks: "Customer remarks",
                BackOfficeRemarks: "Back office remarks",
                HandlingCharges: "Handling charges",
                FinishButton: "Finish",
                DidNotShowButton: "Did not show",
                DeleteButton: "Delete",
                RegistrationDetails: "Registration details",
                EditRegistration: "Edit Registration",
                NewRegistration: "New Registration",
                EditRecRegistration: "Edit Recurring Registration",
                NewRecRegistration: "New Recurring Registration",

                finish: "finish",
                didNotShow: "did not show",

                // week days picker title
                weekDaysTitle: "Weekdays",

                Monday: "Monday",
                Tuesday: "Tuesday",
                Wednesday: "Wednesday",
                Thursday: "Thursday",
                Friday: "Friday",
                Saturday: "Saturday",
                Sunday: "Sunday",

                EveryDay: "Every Day",
                OnlyToday: "Only Today",

                future: "future",
                today: "today",
                expired: "expired",

                // Driver registration
                Driver_Registration: "Driver Registration",
                Driver_Overview: "Driver Overview",

                // Driver overview
                IdNumber: "ID number",
                IdType: "ID type",
                Vehicle: "Vehicle",
                PreRegistered: "Pre-registered",
                SetPreRegistered: "Set registration status to pre-registered",
                NotPreRegistered: "Not pre-registered",
                SetNotPreRegistered:
                    "Set registration status to not pre-registered",
                UnsetTooltip: "Unset registration status",
                NotSet: "Not set",
                CreationDate: "Created at",
                DockNumber: "Dock number",
                Comment: "Comment",

                // Vehicle
                Car: "Car",
                Van: "Van",
                Truck: "Truck",
                Trailer_Truck: "Trailer Truck",

                // Footers
                Total_items: "Total items",
                Archive_total: "Total items for the requested period",

                // Popup
                PopupText: "Please confirm the action",
                ConfirmButton: "Confirm",

                // Other
                Now: "now",
            },
        },
        nl: {
            message: {
                // home page title

                Welcome: "Welkom bij de FT207 website van CTS GROUP",

                // error messages

                FieldRequired: "Dit veld is verplicht.",
                FirstCharRule:
                    "Bedrijfsnaam moet beginnen met een hoofdletter of een cijfer.",
                FirstCharTransporter:
                    "De naam van de vervoerder moet beginnen met een hoofdletter of een cijfer.",
                NameLengthRule:
                    "Bedrijfsnaam mag niet meer dan 44 tekens bevatten.",
                InvalidEmail: "Ongeldig e-mail.",
                InvalidTime: "Ongeldige tijd.",
                InvalidDate: "Ongeldige datum.",
                DateError: "Aankomstdatum en -tijdfout. Controleer uw invoer.",
                OnlyLetters: "Alleen brieven.",
                Max19Chars: "Maximaal 19 tekens toegestaan",
                Max31Chars: "Maximaal 31 tekens toegestaan",
                Max44Chars: "Maximaal 44 tekens toegestaan",
                Max59Chars: "Maximaal 59 tekens toegestaan",
                Max63Chars: "Maximaal 63 tekens toegestaan",
                Max127Chars: "Maximaal 127 tekens toegestaan",
                SpecialCharacters:
                    "Sommige speciale tekens zijn niet toegestaan",
                OnlyInteger: "Alleen geheel getal",

                // common use
                Company: "Bedrijf", // used in company and users entities
                Add: "Toevoegen",

                // toolbar
                Home: "Home",
                Users: "Gebruikers",
                Registrations: "Registraties",
                Recurring_Registrations: "Terugkerende Registraties",
                Registrations_Archive: "Registraties Archief",
                ResetToDefaultDates: "Reset naar standaarddatums",
                Settings: "Instellingen",
                LogOut: "Uitloggen",
                Updated: "Bijgewerkt",
                UnableToRefresh: "Kan niet vernieuwen",

                // search option
                Search: "Zoeken",
                YourSearch: "Uw zoektocht naar",
                NoResults: "vond geen resultaten",

                // home
                TotalToday: "Totaal<br>Vandaag",
                FinishedToday: "Klaar<br>Vandaag",
                DidNotShowToday: "Niet getoond<br>Vandaag",
                OpenToday: "Open<br>Vandaag",
                Total: "Totaal",
                Finished: "Afgewerkt",
                DidNotShowUp: "Kwam niet opdagen",

                // company
                Companies: "Bedrijven",
                AddCompany: "Voeg bedrijf toe",
                NewCompany: "Nieuw Bedrijf",
                EditCompany: "Edit Bedrijf",

                // users
                NewUser: "Nieuwe gebruiker",
                EditUser: "Bewerk gebruiker",
                ListUsersTitle: "Gebruikers",
                Name: "Naam",
                Email: "E-mail",
                Phone: "Telefoonnummer",
                Ldap: "Ldap Login",
                Group: "Groep",
                Actions: "Acties",
                SaveButton: "Opslaan",
                CancelButton: "Annuleren",

                // truck registrations list
                FormTrucksTitle: "Vrachtwagens Registraties",
                Status: "Staat",
                Days: "Dagen",
                Date: "Datum",
                Time: "Tijd",
                Type: "Type",
                Transporter: "Transporteur",
                Reference: "Referentienummer",
                LastModified: "Laatst gewijzigd",
                registerButton: "Registreren",
                From: "van",
                To: "tot",
                NotKnown: "Niet bekend ",
                Undo: "Ongedaan maken",
                Busy: "Let op: houd rekening met langere wachttijden i.v.m. drukte",

                // truck registrations form

                // email address and company name are already defined
                ContactPerson: "Contactpersoon",
                StartDate: "Startdatum",
                EndDate: "Einddatum",
                ArrivalTimeFrom: "Aankomsttijd van",
                ArrivalTimeTo: "Aankomsttijd tot",
                // type, ref num and trasporter are already defined
                NameDriver: "Naam chauffeur",
                LicensePlate: "Kenteken",
                Dock: "Dok",
                CustomerRemarks: "Klantopmerkingen",
                BackOfficeRemarks: "Opmerkingen van de backoffice",
                HandlingCharges: "Administratiekosten",
                FinishButton: "Eindigen",
                DeleteButton: "Verwijderen",
                DidNotShowButton: "Niet getoond",
                RegistrationDetails: "Registratie details",
                EditRegistration: "Bewerk registratie",
                NewRegistration: "Nieuwe registratie",
                EditRecRegistration: "Bewerk terugkerende registratie",
                NewRecRegistration: "Nieuwe terugkerende registratie",

                finish: "eindigen",
                didNotShow: "niet getoond",

                // week days picker title
                weekDaysTitle: "Doordeweekse dagen",

                Monday: "Maandag",
                Tuesday: "Dinsdag",
                Wednesday: "Woensdag",
                Thursday: "Donderdag",
                Friday: "Vrijdag",
                Saturday: "Zaterdag",
                Sunday: "Zondag",

                EveryDay: "Elke Dag",
                OnlyToday: "Alleen Vandaag",
                future: "toekomst",
                today: "vandaag",
                expired: "verlopen",

                // Driver_Reg
                Driver_Registration: "Registratie Van De Bestuurder",
                Driver_Overview: "Bestuurders Overzicht",

                // Driver overview
                IdNumber: "ID-nummer",
                IdType: "ID type",
                Vehicle: "Vehicle",
                PreRegistered: "Vooraf geregistreerd",
                SetPreRegistered:
                    "Stel de registratiestatus in op vooraf geregistreerd",
                NotPreRegistered: "Niet vooraf geregistreerd",
                SetNotPreRegistered:
                    "Stel de registratiestatus in op niet vooraf geregistreerd",
                UnsetTooltip: "Status wijzigen in niet ingesteld",
                NotSet: "Niet ingesteld",
                CreationDate: "Gemaakt bij",
                Comment: "Commentaar",
                DockNumber: "Docknummer",

                // Vehicle
                Car: "Auto",
                Van: "Van",
                Truck: "Vrachtauto",
                Trailer_Truck: "Aanhangwagen",

                // Footers
                Total_items: "Totaal items",
                Archive_total: "Totaal items voor de gevraagde periode",

                // Popup
                PopupText: "Bevestig de actie a.u.b.",
                ConfirmButton: "Bevestigen",

                // Other
                Now: "nu",
            },
        },
    },
});
